export const indonesian = {
  translation: {
    // ================================= titles =================================
    titles: {
      popular_add_ons: 'Popular add-ons',
      top: 'TOP',
      hello: 'Hello',
      in_your_cart: 'In your cart',
      search_result: 'Search results for',
      no_items_found: '0 items found',
      search_empty: 'No results to show',
      call_staff: "We've received your call",
      sub_total: 'Subtotal',
      total: 'Total',
      order_details: 'Order details',
      order_history: 'Order History',
      popup_pay: 'Are you ready to pay?',
      payment_success: "We've received your request to pay",
      order_empty: 'Your order is empty',
      pending: 'Pending',
      served: 'Confirmed',
      confirmed: 'Confirmed',
      cancelled: 'Cancelled',
      ready_to_order: 'Ready to order?',
      order_success: "We've received your order",
      maxQuantityPerOrder: 'Max. quantity/order',
      topping_type_quantity: 'Min {{min}} - Max {{max}}',
      menu_excludes_vat: 'This price excludes VAT.',
      rescanQR: 'Scan QR code to order again.',
      choose_language_to_start: 'Choose your language now',
      customizedService: 'Customized service for you',
      selectOption: 'Please select an option',
      call_staff_reasons: 'Call staff',
      choose_payment_method: 'Choose your method of payment',
      payment_successfully: 'Payment successfully',
      payment_failed: 'Payment failed',
      how_was_your_experience: 'How was your experience?',
      your_details: 'Your details',
      how_many_people: 'How many people are you ?',
      choose_number_of_people: 'Please select the number of people at your table today:',
      buffet: 'Buffet',
      next: 'Next',
      done: 'Done',
      confirm: 'Confirm',
      order_placed: 'Order placed!',
      order_code: 'Order code',
      review_order: 'Write us a review here too',
      popular: 'Popular',
      hope_you_enjoyed: 'Hope you enjoyed.',
      review_success: 'Thank you very much !',
      popup_food_error_order:
        'The dish <span style="font-weight:{{fontWeight}}">{{nameFood}}</span> out of stock!',
      popup_topping_error_order:
        'The topping <span style="font-weight:{{fontWeight}}">{{nameTopping}}</span> out of stock!',
      input_a_name: 'Input a name',
      why_we_need_it: 'Why we need it ?',
      // tablet
      search: 'Search',
      call_staff_tablet: 'Call staff',
      bill: 'Bill',
      pay: 'Pay',
      table_number: 'Tablet Number:',
      ask_for_bill: 'ASK FOR BILL',
      ask_for_bill_decription: 'Tap on “ASK FOR BILL” so we can bring the bill for you.',
      not_yet: 'Not yet',
      quantity: 'Quantity',
      item_table: 'Item',
      status_table: 'Status',
      price_table: 'Price',
      other: 'Other',
    },
    // ================================= descriptions =================================
    descriptions: {
      reached_end: 'You’ve reached the end',
      cart_empty: 'Your cart is empty',
      hint_cart_empty: 'Click here to see the menu',
      search_empty: 'Please check spelling or try different keywords',
      call_staff: "We'll be attending to your table very soon, thank you for your patience",
      popup_pay: "Tap on 'Payment request' so we can bring the bill to your table",
      payment_success: "We'll be attending to your table very soon, thank you for your patience",
      restaurant_on_capichi:
        'If you wish to have the same experience at home, please find us on <span style="color:{{colorText}}">Capichi Delivery</span>',
      order_empty: 'Start your order by adding the dish(es) you wish to dine',
      orderNotFound: 'Order not found!',
      order_success:
        'We’ll be serving your order as soon as possible, thank you for your patience.',
      rescanQR:
        "We're sorry, since your previous order has been finalized, you now need to scan the QR code again to be able to order from that restaurant.",
      order_food_and_drink: 'Order food and drink anytime you want',
      seek_for_help: 'Seek for help from staff directly online',
      ask_to_pay: 'Ask to pay when you’re done eating',
      or_ask_directly: 'or ask directly',
      haveVAT: 'VAT {{vatRate}}% is excluded',
      haveServiceFee: 'We have a service charge of {{serviceRate}}%',
      popup_payment_success:
        'Your online payment is confirmed. We thank you for choosing us today and hope that you had a wonderful time and experience.',
      popup_payment_failed:
        'The payment was unsuccessful due to an abnormality. Please try again later or use another payment method.',
      tap_to_save_screen: 'Please show this screen to the staff at the store',
      checkouted_order: `Thank you for choosing us today for your meal, we sincerely hope you liked your time spent with us.
      We’d really appreciated if you could share about your experience below so that we can grow and improve our restaurant.`,
      review_success:
        'Your review has been received and we will take it into consideration for our next learning step. You’ve been really helpful !',
      input_a_name:
        'You are currently ordering from a table with different orders, to make sure we split the orders correctly, please input a simple name* to identify your order.',
    },
    // ================================= actions =================================
    actions: {
      call_staff: "Seek staff's assistance",
      pay: 'Pay',
      back_to_top: 'Back to top',
      order: 'Order',
      go_back: 'Go back',
      see_menu: 'View menu',
      order_now: 'Order now',
      clear_all: 'Clear all',
      search_again: 'Search again',
      retry: 'Retry',
      back_to_menu: 'Back to menu',
      ask_for_bill: 'Payment request',
      not_yet: 'Not yet',
      discover: 'Discover',
      delete_dish: 'Delete',
      noteFood: 'Tap to add your personal request',
      addToCart: 'Add to cart',
      addNote: 'Add notes',
      confirmOrder: 'Confirm',
      start_ordering: 'Start ordering',
      pay_online: 'Pay online',
      send: 'Send',
      try_again: 'Try again',
      call_staff_for_help: 'Call staff for help',
      skip: 'Skip',
      order_from_here: 'Order from here',
      tap_to_save_screen: 'Tap to save the screen',
      see_a_menu: 'See a menu',
      update: 'Update',
      cancel: 'Cancel',
    },
    // ================================= errors =================================
    errors: {
      server_error: "Sorry, server unfortunately can't be reached",
      errorOutOfStock: 'Sorry, this item is out of stock, please order another one.',
      errorQuantityPerOrder:
        'The number of dishes you have selected has exceeded the maximum quantity. Please choose again.',
      errorQuantityExceeded:
        'Sorry, the requested quantity for this item is currently unavailable. Please change the quantity for this item.',
      somethingWrong: 'Something went wrong, please try again!',
      errorFoodHasChanged:
        'Sorry, this restaurant has just updated new information, please reset the cart.',
      warningMin: 'Please order a minimum {{min}} topping',
      warningMax: 'Please only order a maximum {{max}} topping',
      notFoundFoodItem:
        'Sorry, the restaurant temporarily stopped serving this dish. Please try again later.',
      errorNotOpenTable: `Your table hasn't opened yet. Please call staff to support.`,
      max_comment_review: 'Up to {{max}} characters',
      payment_method_changed: 'Payment method has changed.',
      payment_method_changed_desc: 'Please refresh the page and choose your payment method again.',
      max_characters: 'Up to {{max}} characters',
      required_floor: 'Please enter your floor',
      required_room: 'Please enter your room.',
      required_full_name: 'Please enter your full name',
      errorOutOfStockNEC: 'Out of stock',
      rating_already_existed: 'Sorry. This order has been evaluated',
    },
    // ================================= languages =================================
    languages: {},
    // ================================= label =================================
    label: {
      zezoYen: '0 yen',
      required: 'Required',
      optional: 'Optional',
      my_cart: 'My cart',
      items_found: 'Items found',
      sold_out: 'SOLD OUT',
      items: 'item(s)',
      powered_by: 'Powered by',
      vat: 'VAT',
      service_fee: 'Service fee',
      your_order: 'Your order',
      or: 'or',
      payment_methods: {
        international_card: 'Credit card',
        atm: 'ATM',
        qr_code: 'QR Transfer',
        e_wallet: 'E-wallet',
      },
      review_or_comment: 'Leave us a review or a comment',
      only_letters: 'only letters are accepted',
    },
    // ================================= placeholder =================================
    placeholder: {
      input_search: 'Search for dishes, menu, drinks...',
      choose_your_floor: 'Choose your floor',
      choose_your_room: 'Choose your room',
      your_full_name: 'Your full name',
      no_results: 'No results',
      your_name: 'Your name',
    },
    popup_start_buffet: {
      course_menu_has_started: '"Course menu" has started',
      time_limit: 'Time limit',
      time_value: '{{value}} mins',
      see_menu: 'See menu',
    },
    popup_add_friend_line: {
      line: 'LINE',
      description: 'Please add us as a LINE friend to use the mobile ordering service.',
      add_friend_btn: 'Add as a LINE Friend',
      already_added: 'Already Added as a Friend',
    },
  },
}
